module.exports = __webpack_public_path__ + "media/public/images/error/artists-b0542ea0d3392162c0ad1a88f6b825a5.jpg";